/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Add = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Add 24">
      <g className="SVG">
        <path fill="#0E0E0E" d="M22 11a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h20Z" />
        <path fill="#0E0E0E" d="M13 22a1 1 0 1 1-2 0V2a1 1 0 1 1 2 0v20Z" />
      </g>
    </g>
  </svg>
);

export const AddIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'add-icon'}
      icon={Add}
      {...props}
      size={size}
    />
  );
};
